import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminImage } from '../../../api/cabsAdmin';

const AdminCabsLocations = () => (
  <CabCrudPage
    title="Locations"
    description="Manage serviceable cities, hubs, and pickup points."
    resource="locations"
    defaultItem={{
      name: '',
      slug: '',
      imageUrl: '',
      city: '',
      state: '',
      country: '',
      timezone: '',
      latitude: '',
      longitude: '',
      isActive: true,
    }}
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'city', label: 'City' },
      { key: 'state', label: 'State' },
      { key: 'country', label: 'Country' },
    ]}
    fields={[
      { name: 'name', label: 'Name', required: true },
      { name: 'slug', label: 'Slug', required: true },
      { name: 'imageUrl', label: 'Location image', type: 'image', col: 'col-12' },
      { name: 'city', label: 'City', required: true },
      { name: 'state', label: 'State' },
      { name: 'country', label: 'Country', required: true },
      { name: 'timezone', label: 'Timezone' },
      { name: 'latitude', label: 'Latitude', type: 'number' },
      { name: 'longitude', label: 'Longitude', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
    transformPayload={(payload) => ({
      ...payload,
      latitude: payload.latitude === '' ? null : Number(payload.latitude),
      longitude: payload.longitude === '' ? null : Number(payload.longitude),
      state: payload.state || null,
      timezone: payload.timezone || null,
    })}
    uploadHandler={uploadAdminImage}
  />
);

export default AdminCabsLocations;
